export const style = {
  messageTime: {
    color: "var(--orange-500)",
    fontSize: "1.2rem",
    fontWeight: 400,
    lineHeight: "99.538%",
  },
  messageUnReadCount: {
    marginLeft: "0.4rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "2rem",
    height: "2rem",
    gap: "0.4rem",
    borderRadius: "1rem",
    background: "var(--orange-500)",
  },
  messageUnReadCountText: {
    color: "var(--neutral-100)",
    fontSize: "1.2rem",
    fontWeight: 600,
  },
  messageStartMentionUnReadCount: {
    marginLeft: "0.3rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0.4rem",
    width: "3.7rem",
    height: "2rem",
    gap: "0.4rem",
    borderRadius: "1rem",
    background: "var(--orange-500)",
  },
};
